import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, isValid } from 'date-fns';
import config from '../../../config';

const UtilityNew = ({ selectedDate }) => {
  const [data, setData] = useState({
    '전력(KW)': {
      사용량: { 목표: '', 실적: '' },
      누계사용량: { 목표: '', 실적: '' },
      '누계금액(Ton)': { 목표: '', 실적: '' },
      누계금액: { 목표: '', 실적: '' },
    },
    'LNG(ℓ)': {
      사용량: { 목표: '', 실적: '' },
      누계사용량: { 목표: '', 실적: '' },
      '누계금액(Ton)': { 목표: '', 실적: '' },
      누계금액: { 목표: '', 실적: '' },
    },
  });
  const [loading, setLoading] = useState(false); // 로컬 로딩 상태 추가

  const dateObj = new Date(selectedDate);
  const formattedDate = isValid(dateObj) ? format(dateObj, 'yyyyMMdd') : null;

  useEffect(() => {
    const fetchData = async () => {
      if (!formattedDate) return;

      setLoading(true); // 로딩 시작

      try {
        const response = await axios.post(
          `${config.apiUrl}/utilSel.do`,
          { stdate: formattedDate },
          { headers: { 'Content-Type': 'application/json' } },
        );

        const apiData = response.data;

        const transformedData = transformData(apiData.resultData);
        setData(transformedData);
      } catch (err) {
        console.error("데이터를 가져오는 중 에러 발생:", err);
      } finally {
        setLoading(false); // 로딩 종료
      }
    };

    fetchData();
  }, [formattedDate]);

  const transformData = resultData => {
    const transformed = {
      '전력(KW)': {
        사용량: { 목표: '', 실적: '' },
        누계사용량: { 목표: '', 실적: '' },
        '누계금액(Ton)': { 목표: '', 실적: '' },
        누계금액: { 목표: '', 실적: '' },
      },
      'LNG(ℓ)': {
        사용량: { 목표: '', 실적: '' },
        누계사용량: { 목표: '', 실적: '' },
        '누계금액(Ton)': { 목표: '', 실적: '' },
        누계금액: { 목표: '', 실적: '' },
      },
    };

    resultData.forEach(entry => {
      const title = entry.TITLE === 'ELEC' ? '전력(KW)' : 'LNG(ℓ)';

      if (title === '전력(KW)') {
        transformed[title].사용량 = {
          목표: entry.DAY_GOALS ? entry.DAY_GOALS.substring(0, entry.DAY_GOALS.length - 2) : '',
          실적: entry.USETOT ? entry.USETOT.substring(0, entry.USETOT.length - 2) : '',
        };
        transformed[title].누계사용량 = {
          목표: entry.MON_GOALS ? entry.MON_GOALS.substring(0, entry.MON_GOALS.length - 2) : '',
          실적: entry.USESUM ? entry.USESUM.substring(0, entry.USESUM.length - 2) : '',
        };
      } else if (title === 'LNG(ℓ)') {
        transformed[title].사용량 = {
          목표: entry.DAY_GOALS ? entry.DAY_GOALS.substring(0, entry.DAY_GOALS.length - 1) : '',
          실적: entry.USETOT ? entry.USETOT.substring(0, entry.USETOT.length - 1) : '',
        };
        transformed[title].누계사용량 = {
          목표: entry.MON_GOALS ? entry.MON_GOALS.substring(0, entry.MON_GOALS.length - 1) : '',
          실적: entry.USESUM ? entry.USESUM.substring(0, entry.USESUM.length - 1) : '',
        };
      }

      transformed[title]['누계금액(Ton)'] = {
        목표: '',
        실적: entry.WONT || '',
      };
      transformed[title].누계금액 = {
        목표: '',
        실적: entry.WON || '',
      };
    });

    return transformed;
  };

  const categories = ['사용량', '누계사용량', '누계금액(Ton)', '누계금액'];
  const metrics = ['목표', '실적'];

  return (
    <div className='relative mt-[4%]'>
      {loading && (
        <div className='absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center z-10'>
          <div className="text-white text-2xl font-bold">Loading...</div>
          </div>)}
      <div className='w-[25%] change_2h page_center bg-blue-200 font-bold text-blue-600'>Utility</div>
      <div className='nob2_border'>
        <div className=''>
          <div className='flex flex-row w-[100%]'>
            <div className='w-[50%] change_2h b2-b b2-r page_center'>구분</div>
            <div className='w-[25%] change_2h b2-r b2-b page_center'>전력(KW)</div>
            <div className='w-[25%] change_2h b2-b page_center'>LNG(ℓ)</div>
          </div>
          <div className='w-[100%] flex flex-row'>
            <div className='w-[50%] flex flex-col '>
              {categories.map(category => (
                <div key={category} className='flex flex-row w-[100%]'>
                  <div className='w-[100%] change_2h2 b2-b b2-r page_center '>{category}</div>
                  <div className='flex flex-col w-[100%]'>
                    {metrics.map((metric, index) => (
                      <div
                        key={metric}
                        className={`w-[100%] b2-r change_2h page_center overflow-hidden text-ellipsis whitespace-nowrap ${
                          metric === '실적' ? 'b2-b' : 'b-g'
                        } ${category === '누계금액' && index === metrics.length - 1 ? 'b2-b' : ''}`}
                      >
                        {metric === '목표' ? (
                          <>
                            <div className='mx-2'>목</div>
                            <div className='mx-2'>표</div>
                          </>
                        ) : (
                          <>
                            <div className='mx-2'>실</div>
                            <div className='mx-2'>적</div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className='flex flex-row w-[50%]'>
              <div className='flex flex-col w-[50%] b2-r h-[100%]'>
                {categories.map(category => (
                  <div key={category} className='flex flex-col'>
                    {metrics.map((metric, index) => (
                      <div
                        key={metric}
                        className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap ${
                          metric === '실적' ? 'b2-b' : 'b-g'
                        } ${category === '누계금액' && index === metrics.length - 1 ? 'b2-b' : ''}`}
                      >
                        {data['전력(KW)'][category][metric]}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className='flex flex-col w-[50%] h-[100%]'>
                {categories.map(category => (
                  <div key={category} className='flex flex-col'>
                    {metrics.map((metric, index) => (
                      <div
                        key={metric}
                        className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap ${
                          metric === '실적' ? 'b2-b' : 'b-g'
                        } ${category === '누계금액' && index === metrics.length - 1 ? 'b2-b' : ''}`}
                      >
                        {data['LNG(ℓ)'][category][metric]}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UtilityNew;
